// extracted by mini-css-extract-plugin
export default {"root":"PrintSinglePreviewLayout_root__zGSwC"};